import "echarts";
import ECharts, * as exported from "./index";

export default Object.assign(ECharts, exported);
